import {
  customScrollMinimal,
  Drawer,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container},${Drawer.Styled.BackgroundOverlay} {
    z-index: 2;
  }
`;

export const Container = styled.section`
  overflow-x: auto;
  overscroll-behavior-x: contain;
  ${customScrollMinimal}
  padding: 16px;
`;

export const SpinnerContainer = styled.section`
  overflow-x: auto;
  overscroll-behavior-x: contain;
  ${customScrollMinimal}
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const Subtitle = styled.p`
  color: var(--text-default);
  ${typographyV2.bodySm}
  margin-bottom: 32px;
`;
